
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"251","height":"84","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M250 42c0 5.363-3.247 10.63-9.483 15.564-6.225 4.926-15.295 9.405-26.592 13.186C191.341 78.308 160.078 83 125.5 83c-34.578 0-65.84-4.692-88.424-12.25-11.298-3.78-20.368-8.26-26.593-13.186C4.247 52.63 1 47.363 1 42c0-5.363 3.247-10.63 9.483-15.564 6.225-4.926 15.295-9.405 26.592-13.186C59.66 5.692 90.922 1 125.5 1c34.578 0 65.841 4.692 88.425 12.25 11.297 3.78 20.367 8.26 26.592 13.186C246.753 31.37 250 36.637 250 42z","fill":"#D2D2DE","stroke":"#000","stroke-width":"2"}}),_c('path',{attrs:{"d":"M197.821 34.951l-.037.134v.139c0 2.99-1.789 5.991-5.379 8.863-3.58 2.864-8.821 5.487-15.387 7.709C163.896 56.236 145.705 59 125.565 59c-20.14 0-38.332-2.764-51.453-7.204-6.566-2.222-11.808-4.845-15.388-7.71-3.59-2.87-5.378-5.873-5.378-8.862v-.059l-.007-.058c-1.53-13.06 2.254-20.65 8.518-24.95 6.372-4.372 15.536-5.507 25.082-5.07 9.51.436 19.206 2.421 26.5 4.104 1.566.362 3.032.712 4.361 1.03 1.741.415 3.247.775 4.436 1.03 1.044.225 1.917.386 2.528.43.278.02.64.03.957-.068.163-.051.454-.173.659-.475.09-.133.144-.271.171-.405.062-.037.144-.083.253-.137.499-.247 1.308-.545 2.413-.87 2.197-.645 5.406-1.352 9.274-1.976 7.735-1.247 18.007-2.148 27.908-1.588 9.939.561 19.33 2.586 25.45 7.046 3.037 2.213 5.251 5.012 6.356 8.533 1.107 3.528 1.128 7.87-.384 13.21zm-71.428-24.104l.009-.01a.066.066 0 01-.009.01z","fill":"#7D8576","stroke":"#000","stroke-width":"2"}})])
          )
        }
      }
    